import { useRef, useState } from 'react';
import { QRCodeCanvas } from 'qrcode.react';
import { Download, Printer, Share2, Copy, CheckCircle, X } from 'lucide-react';

// urlPublica se arma con el ID numérico del código: /MascotaProtegida/{codigo.id}
const QRModal = ({ codigo, onClose }) => {
    const qrRef = useRef();
    const [copied, setCopied] = useState(false);

    const urlPublica = `https://tagsmartpet.com/MascotaProtegida/${codigo.id}`;
    const nombreArchivo = codigo.mascotaNombre && codigo.mascotaNombre !== '—' ? codigo.mascotaNombre : codigo.codigo_unico;

    const descargarQR = () => {
        const canvas = qrRef.current?.querySelector('canvas');
        if (!canvas) return;
        const link = document.createElement('a');
        link.download = `QR-${nombreArchivo}.png`;
        link.href = canvas.toDataURL('image/png');
        link.click();
    };

    const imprimirQR = () => {
        const canvas = qrRef.current?.querySelector('canvas');
        if (!canvas) return;
        const ventana = window.open('', '_blank');
        if (!ventana) return;
        ventana.document.write(`
      <html>
        <head><title>QR de ${nombreArchivo}</title></head>
        <body style="display:flex;justify-content:center;align-items:center;min-height:100vh;margin:0;background:#f5f5f5;">
          <img src="${canvas.toDataURL('image/png')}" style="max-width:80%;border:2px solid #ddd;border-radius:16px;box-shadow:0 4px 20px rgba(0,0,0,0.1);" />
        </body>
      </html>
    `);
        ventana.document.close();
        ventana.focus();
        ventana.print();
    };

    const compartir = async () => {
        if (navigator.share) {
            try {
                await navigator.share({
                    title: `QR de ${nombreArchivo}`,
                    text: 'Escaneá este código para ver el perfil de la mascota',
                    url: urlPublica,
                });
            } catch {
                // usuario canceló el share, no hacer nada
            }
        } else {
            copiarEnlace();
        }
    };

    const copiarEnlace = async () => {
        try {
            await navigator.clipboard.writeText(urlPublica);
            setCopied(true);
            setTimeout(() => setCopied(false), 2500);
        } catch {
            alert('Copiá este enlace: ' + urlPublica);
        }
    };

    return (
        <div className="sp-modal-backdrop" onClick={onClose}>
            <div
                className="sp-modal"
                style={{ maxWidth: 420, textAlign: 'center', position: 'relative' }}
                onClick={(e) => e.stopPropagation()}
            >
                <button
                    onClick={onClose}
                    style={{ position: 'absolute', top: 14, right: 14, background: 'none', border: 'none', cursor: 'pointer', padding: 4 }}
                >
                    <X size={20} />
                </button>

                <h3 className="sp-modal__title">Código {codigo.codigo_unico}</h3>
                <p style={{ fontSize: '0.85rem', color: 'var(--sp-muted)', marginTop: -8, marginBottom: '1rem' }}>
                    {codigo.usado ? `Vinculado a ${codigo.mascotaNombre}` : 'Escaneá este código para ver el perfil de la mascota'}
                </p>

                <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '1.25rem' }}>
                    <div
                        ref={qrRef}
                        style={{ background: '#fff', padding: 12, borderRadius: 16, border: '1px solid #eee', display: 'inline-block' }}
                    >
                        <QRCodeCanvas
                            value={urlPublica}
                            size={220}
                            bgColor="#ffffff"
                            fgColor="#1e1e2f"
                            level="H"
                            includeMargin
                        />
                    </div>
                </div>

                <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center', gap: '0.5rem', marginBottom: '1rem' }}>
                    <button className="sp-btn sp-btn--primary" onClick={descargarQR}>
                        <Download size={16} /> Descargar
                    </button>
                    <button className="sp-btn sp-btn--light" onClick={imprimirQR}>
                        <Printer size={16} /> Imprimir
                    </button>
                    <button className="sp-btn sp-btn--light" onClick={compartir}>
                        <Share2 size={16} /> Compartir
                    </button>
                </div>

                <div
                    style={{
                        display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '0.5rem',
                        background: 'var(--sp-bg-alt, #f5f5f5)', borderRadius: 10, padding: '0.6rem 0.85rem',
                        fontSize: '0.8rem', color: 'var(--sp-muted)', border: '1px solid #eee',
                    }}
                >
                    <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', maxWidth: 220 }}>
                        {urlPublica}
                    </span>
                    <button
                        onClick={copiarEnlace}
                        style={{ background: 'none', border: 'none', cursor: 'pointer', flexShrink: 0, padding: 4 }}
                        title="Copiar enlace"
                    >
                        {copied ? <CheckCircle size={16} color="#22a559" /> : <Copy size={16} />}
                    </button>
                </div>
                {copied && (
                    <p style={{ fontSize: '0.75rem', color: '#22a559', fontWeight: 700, marginTop: '0.5rem' }}>
                        ¡Enlace copiado!
                    </p>
                )}
            </div>
        </div>
    );
};

export default QRModal;